var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29636_344467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29636_344467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75531 36.9898V34.8956H33.2428V36.9898H6.75531ZM6.75531 5.10979V3.01562H33.2428V5.10979H6.75531ZM19.9991 22.4235C21.2735 22.4235 22.3485 21.9848 23.2241 21.1073C24.0996 20.2295 24.5374 19.152 24.5374 17.8748C24.5374 16.6003 24.0996 15.5253 23.2241 14.6498C22.3485 13.774 21.2735 13.336 19.9991 13.336C18.7246 13.336 17.6496 13.7744 16.7741 14.651C15.8985 15.5274 15.4607 16.6034 15.4607 17.879C15.4607 19.1545 15.8985 20.2309 16.7741 21.1081C17.6496 21.9851 18.7246 22.4235 19.9991 22.4235ZM6.61448 32.5027C5.89809 32.5027 5.28448 32.2473 4.77365 31.7365C4.26309 31.2256 4.00781 30.612 4.00781 29.8956V10.1098C4.00781 9.36174 4.26309 8.74021 4.77365 8.24521C5.28448 7.75021 5.89809 7.50271 6.61448 7.50271H33.3836C34.1 7.50271 34.7136 7.75813 35.2245 8.26896C35.735 8.77979 35.9903 9.3934 35.9903 10.1098V29.8956C35.9903 30.612 35.735 31.2256 35.2245 31.7365C34.7136 32.2473 34.1 32.5027 33.3836 32.5027H6.61448ZM10.4691 30.4085H29.5291C28.2263 28.9727 26.7359 27.8987 25.0578 27.1865C23.3798 26.4742 21.6953 26.1181 20.0045 26.1181C18.295 26.1181 16.6116 26.4742 14.9541 27.1865C13.2968 27.8987 11.8018 28.9727 10.4691 30.4085Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1Icon);
export default __webpack_public_path__ + "static/media/c1Icon.281b7503f93d4a04acf201dd2fa46f50.svg";
export { ForwardRef as ReactComponent };